var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 20,
    role: "img",
    "aria-label": "Unity",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Unity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 57,
    height: 20,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPlVuaXR5PC90aXRsZT48cGF0aCBkPSJtMTIuOTI4OCA0LjI5MzkgMy43OTk3IDIuMTkyOWMuMTM2Ni4wNzcuMTQxNS4yOTA1IDAgLjM2NzVsLTQuNTE1IDIuNjA3NmEuNDE5Mi40MTkyIDAgMCAxLS40MjQ2IDBMNy4yNzQgNi44NTQzYy0uMTM5LS4wNzQ1LS4xNDE1LS4yOTMgMC0uMzY3NWwzLjc5NzItMi4xOTNWMEwxLjM3NTggNS41OTc3VjE2Ljc5M2wzLjcxNzctMi4xNDU2di00LjM4NThjLS4wMDI1LS4xNTY1LjE4MTMtLjI2ODIuMzE4LS4xODM4bDQuNTE0OCAyLjYwNzZhLjQyNTIuNDI1MiAwIDAgMSAuMjEzNi4zNjc2djUuMjEyN2MuMDAyNS4xNTY1LS4xODEzLjI2ODItLjMxNzkuMTgzOGwtMy43OTk2LTIuMTkyOS0zLjcxNzggMi4xNDU3TDEyIDI0bDkuNjk1NC01LjU5NzctMy43MTc4LTIuMTQ1Ny0zLjc5OTYgMi4xOTI5Yy0uMTM0MS4wODItLjMyMjktLjAyNDgtLjMxNzktLjE4MzhWMTMuMDUzYzAtLjE1NjUuMDg3LS4yOTU2LjIxMzYtLjM2NzZsNC41MTQ5LTIuNjA3NmMuMTM0LS4wODIuMzIyOC4wMjI0LjMxNzkuMTgzOHY0LjM4NThsMy43MTc3IDIuMTQ1NlY1LjU5NzdMMTIuOTI4OCAwWiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 375,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 290
  }, "Unity"), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 290
  }, "Unity"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.f629252b693347eb899dcf0d4746b60e.svg";
export { ForwardRef as ReactComponent };